import React from 'react';

export const DynamicTickIcon = ({ className, ...props }) => {
  return (
    <svg
      {...props}
      xmlns="http://www.w3.org/2000/svg"
      width="63"
      height="63"
      viewBox="0 0 63 63"
      fill="none"
      className={className}
    >
      <g filter="url(#filter0_d_6160_6717)">
        <rect
          x="4.5"
          y="0.498047"
          width="54"
          height="54"
          rx="27"
          fill="white"
          fillOpacity="0.3"
          shapeRendering="crispEdges"
        />
        <rect
          x="5"
          y="0.998047"
          width="53"
          height="53"
          rx="26.5"
          stroke="#AB9005"
          shapeRendering="crispEdges"
        />
        <circle cx="31.5" cy="27.498" r="17" fill="var(--color-primary)" />
        <path
          d="M38.432 26.3867V23.3633C34.4795 23.1965 34.3548 19.6051 34.3499 19.2679V19.2422H31.2981V31.0176C31.298 31.5268 31.1374 32.0229 30.839 32.4354C30.5406 32.848 30.1197 33.1559 29.6362 33.3154C29.1527 33.4749 28.6312 33.4778 28.146 33.3237C27.6607 33.1697 27.2364 32.8665 26.9334 32.4574C26.6304 32.0482 26.4642 31.5539 26.4584 31.0448C26.4526 30.5357 26.6075 30.0377 26.9011 29.6218C27.1947 29.2058 27.612 28.893 28.0936 28.728C28.5752 28.5629 29.0966 28.554 29.5837 28.7024V25.5836C28.4791 25.4401 27.357 25.6366 26.367 26.147C25.377 26.6574 24.566 27.4574 24.0422 28.4404C23.5184 29.4234 23.3066 30.5427 23.435 31.6491C23.5634 32.7555 24.026 33.7965 24.7611 34.6333C25.4962 35.4702 26.4689 36.0631 27.5495 36.3331C28.6301 36.6031 29.7674 36.5373 30.8097 36.1446C31.852 35.7519 32.7499 35.0508 33.3836 34.1348C34.0174 33.2188 34.3569 32.1315 34.357 31.0176C34.357 30.9409 34.3548 30.8645 34.3517 30.7887V24.9904C35.7582 26.2771 38.432 26.3867 38.432 26.3867Z"
          fill="white"
        />
        <path
          d="M33.5273 19.2422C33.6747 20.044 34.1042 21.2983 35.3589 22.0317C34.4006 20.9158 34.3517 19.4756 34.35 19.2679V19.2422H33.5273Z"
          fill="white"
        />
        <path
          d="M38.4322 26.3866V23.3632C38.13 23.3515 37.8293 23.3155 37.5328 23.2559V25.6368C37.5328 25.6368 34.8591 25.5272 33.4507 24.2409V30.0387C33.4538 30.1151 33.4561 30.1909 33.4561 30.2677C33.4561 31.259 33.1871 32.2318 32.6779 33.0824C32.1686 33.9329 31.4382 34.6294 30.5643 35.0975C29.6905 35.5657 28.706 35.788 27.7158 35.7408C26.7256 35.6936 25.7667 35.3786 24.9414 34.8294C25.7004 35.6137 26.6763 36.1533 27.7441 36.3793C28.8118 36.6053 29.9227 36.5072 30.9343 36.0976C31.946 35.6881 32.8122 34.9857 33.4221 34.0806C34.0319 33.1755 34.3575 32.1089 34.3572 31.0176C34.3572 30.9408 34.355 30.8645 34.3519 30.7886V24.9903C35.7584 26.277 38.4322 26.3866 38.4322 26.3866Z"
          fill="white"
        />
        <path
          d="M28.6822 27.9524C28.0992 27.7755 27.4709 27.825 26.9228 28.0909C26.3746 28.3568 25.9469 28.8197 25.7249 29.3871C25.503 29.9544 25.5031 30.5847 25.7254 31.1519C25.9476 31.7192 26.3755 32.1819 26.9238 32.4475C26.6234 32.0377 26.4596 31.5436 26.4557 31.0355C26.4518 30.5273 26.608 30.0309 26.9021 29.6164C27.1962 29.202 27.6133 28.8907 28.0942 28.7266C28.5751 28.5625 29.0955 28.554 29.5816 28.7022V25.5834C29.3475 25.5536 29.1117 25.5388 28.8757 25.5391C28.8109 25.5391 28.7465 25.5391 28.6822 25.5431V27.9524Z"
          fill="white"
        />
      </g>
      <defs>
        <filter
          id="filter0_d_6160_6717"
          x="0.5"
          y="0.498047"
          width="62"
          height="62"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="4" />
          <feGaussianBlur stdDeviation="2" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_6160_6717"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_6160_6717"
            result="shape"
          />
        </filter>
      </defs>
    </svg>
  );
};
